import LoanTab from "./LoanTab";

export default LoanTab;
